(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-group"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.celvit-faq-item__toggle');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    panel.inert = !expanded;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-list"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-news-more]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    const section = link.closest('[data-news-list]');
    const grid = section.querySelector('[data-news-grid]');
    const status = section.querySelector('[data-news-status]');
    link.setAttribute('aria-disabled', 'true');
    grid.setAttribute('aria-busy', 'true');
    status.textContent = status.dataset.loading;
    try {
      const response = await fetch(link.href);
      if (!response.ok) throw new Error('News request failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextSection = page.querySelector('[data-news-list]');
      const nextGrid = nextSection?.querySelector('[data-news-grid]');
      if (!nextGrid) throw new Error('News grid missing');
      const firstCard = nextGrid.firstElementChild;
      grid.append(...nextGrid.children);
      const nextLink = nextSection.querySelector('[data-news-more]');
      if (nextLink) link.href = nextLink.href;
      else section.querySelector('.celvit-news__more').remove();
      status.textContent = '';
      const firstLink = firstCard?.querySelector('a');
      firstLink?.focus({ preventScroll: true });
    } catch {
      status.textContent = status.dataset.error;
    } finally {
      link.removeAttribute('aria-disabled');
      grid.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
